export class FeltExperienceError extends Error {
  constructor(
    message: string,
    public initialContext?: any
  ) {
    super(message);
    this.name = "ExperienceError";
    this.initialContext = initialContext;
    Object.setPrototypeOf(this, FeltExperienceError.prototype);
  }
}
